<template>
    <div class="IberoHome">
      <ShortCampus :InfoView="IberoCampus" :TitleRef="$ml.get('txtIberoCampus')"/>      
    </div>
</template>

<script>
import {mapState} from 'vuex';
import ShortCampus from '@/components/Shortcuts.vue'
import authentication from '@/store/authentication'
import IberoHelpers from '@/store/helpers.js'


export default {
  name: 'Ibero',
  components:{
      ShortCampus      
  },
  computed: {
    ...mapState(['IberoCampus'])
  },
  created: function () {    
    if (!this.$session.get('IberoJWTLogin')) {
      this.$router.push('Login')
    }    
  }
}
</script>

<style>  
.IberoHome {
    padding-left: 10%;
    padding-right: 10%;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  @media (max-width: 980px) {
    .IberoHome {
      padding-left: 10%;
      padding-right: 10%;
    }
  }
  @media (max-width: 580px) {
    .IberoHome {
      padding-left: 1%;
      padding-right: 1%;
    }
  }


  .MainTitle_RefTitle{
    font-family: 'Montserrat';
    color: #212121;
    clear: both;
    line-height: initial;  
    margin-top: 50px;
    font-size: 24px;
    display: block;
  }

  .MainTitle{
    display: block;
  }  
</style>